// Simple analytics utility
const analytics = {
  track: (event, properties = {}) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Analytics:', event, properties);
      return;
    }
    
    // In production, send to your analytics service
    // Example: gtag('event', event, properties);
  },

  page: (path) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Page view:', path);
      return;
    }
    
    // In production, track page views
    // Example: gtag('config', 'GA_MEASUREMENT_ID', { page_path: path });
  },

  error: (error, context = {}) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error tracked:', error, context);
      return;
    }
    
    // In production, send errors to monitoring service
    // Example: Sentry.captureException(error, { extra: context });
  }
};

export default analytics;